import * as React from 'react';
import { motion } from 'framer-motion';
import { ReactComponent as ImgRainbow } from './images/rainbow.svg';

export const MagicLinkSent: React.FC = () => {
  return (
    <div className="flex flex-col items-center max-w-sm mx-auto">
      <h2 className="text-center">
        Check your email &mdash; magic just happened
      </h2>
      <div className="flex flex-col items-center mt-14">
        <div className="flex justify-between w-24 h-7">
          <motion.div
            initial={{
              opacity: 0,
              scale: 0,
            }}
            transition={{
              delay: 1.0,
              duration: 0.4,
              type: 'spring',
              bounce: 0.2,
            }}
            animate={{
              opacity: 1,
              scale: 1,
            }}
            className="rounded-full w-7 h-7 bg-blue"
          />
          <motion.div
            initial={{
              opacity: 0,
              scale: 0,
            }}
            transition={{
              delay: 1.4,
              duration: 0.4,
              type: 'spring',
              bounce: 0.2,
            }}
            animate={{
              opacity: 1,
              scale: 1,
            }}
            className="rounded-full w-7 h-7 bg-blue"
          />
        </div>
        <div className="w-full max-w-[362px]">
          <motion.div
            initial={{
              rotate: '180deg',
            }}
            transition={{
              duration: 1.0,
              delay: 0,
              type: 'spring',
              bounce: 0.2,
            }}
            animate={{
              rotate: 0,
            }}
          >
            <ImgRainbow width={300} />
          </motion.div>
        </div>
      </div>
    </div>
  );
};
